"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var usePendingState = function (errors) {
    if (errors === void 0) { errors = {}; }
    var _a = react_1.useState(false), pending = _a[0], setPending = _a[1];
    var _b = react_1.useState(false), started = _b[0], setStarted = _b[1];
    react_1.useEffect(function () {
        if (started && Object.keys(errors).length > 0) {
            setPending(false);
            setStarted(false);
        }
        else if (started && !pending && Object.keys(errors).length === 0) {
            setStarted(false);
            setPending(false);
        }
        else if (pending && !started) {
            setStarted(true);
        }
    }, [pending, errors]);
    var togglePending = function () {
        setPending(!pending);
    };
    return [pending, togglePending];
};
exports.default = usePendingState;
//# sourceMappingURL=usePendingState.js.map